import { useQuery } from "@apollo/client";
import { ContentShowQuery } from "../graphql/queries";

/**
 * Хук для загрузки одной единицы контента (для просмотра)
 */
export function useContentShowQuery(id: string | null, skip = false) {
  return useQuery(ContentShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
